import { useEffect, RefObject } from 'react';

/**
 * 캘린더/dropdown/popover 외부 클릭 감지.
 * - active=true일 때만 mousedown 리스너 attach
 * - ref.current가 클릭 타겟을 contains하지 않으면 onOutside() 호출
 */
export const useOutsideClick = (
  ref: RefObject<HTMLElement | null>,
  onOutside: () => void,
  active: boolean = true
) => {
  useEffect(() => {
    if (!active) return;
    const handler = (e: MouseEvent) => {
      const target = e.target as Node | null;
      if (ref.current && target && !ref.current.contains(target)) {
        onOutside();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [ref, onOutside, active]);
};
